import $ from 'jquery';

$(document).ajaxSend((e, xhr, settings) => {
    if (settings.type.toUpperCase() === 'POST') {
        if (settings.contentType.search(/multipart\/form-data|application\/x-www-form-urlencoded/) === -1) {
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        }
    }
});
